export const treeState = {
    state: () => ({
        showTree: false,
    }),

    mutations: {
        setShowTree (state, n) {
            state.showTree = n;
        }
    },

    getters: {
        getShowTree (state) {
            return state.showTree;
        }
    },

    actions: {
    
    }
}

export const benchParam = {
    state: () => ({
        param: '',
        benchId: '',    //视窗id
    }),

    mutations: {
        setParam (state, code) {
            state.param = code;
        },
        setBenchId (state, id) {
            state.benchId = id;
        }
    },

    getters: {
        getParam (state) {
            return state.param;
        },
        getBenchId (state) {
            return state.benchId;
        }
    },
}

export const showState = {
    state: () => ({
        isShow: false,
    }),

    mutations: {
        setShow (state, n) {
            state.isShow = n;
        }
    },

    getters: {
        getShow (state) {
            return state.isShow;
        }
    }
}

export const projectInfo = {
    state: () => ({
        contractCat: '',
        projectProgress: '',
        contractName: '',
        contractNo: '',
        projectStatus: '',
        status: '',
        dataForm: {}
    }),

    mutations: {
        setContractCat (state, n) {
            state.contractCat = n;
        },
        setProjectProgress (state, n) {
            state.projectProgress = n;
        },
        setContractName (state, n) {
            state.contractName = n;
        },
        setContractNo (state, n) {
            state.contractNo = n;
        },
        setProjectStatus (state, n) {
            state.projectStatus = n;
        },
        setStatus (state, n) {
            state.status = n;
        },
        setDataForm (state, n) {
            state.dataForm = n;
        },
    },

    getters: {
        getContractCat (state) {
            return state.contractCat;
        },
        getProjectProgress (state) {
            return state.projectProgress;
        },
        getContractName (state) {
            return state.contractName;
        },
        getContractNo (state) {
            return state.contractNo;
        },
        getProjectStatus (state) {
            return state.projectStatus;
        },
        getStatus (state) {
            return state.status;
        },
        getDataForm (state) {
            return state.dataForm;
        },
    }
}


// WEBPACK FOOTER //
// ./src/vuex/modules.js